<template>
   <div>
       <div class="modal" tabindex="-1" role="dialog">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header p-2" style="height:64px">
                        <h5 class="modal-title">{{annotationData.asset.file_name}}</h5>
                        <button type="button" @click="closeAnnotationWindow()" class="close text-white" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">
                                <CancelIcon class="close-icon" style="height: 40px !important;width: 40px !important;color: #fff;"/>
                            </span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <tui-image-editor @hook:mounted="addUndoNdDeleteBtn()" :include-ui="useDefaultUI" ref="tuiImageEditor" :options="options"></tui-image-editor>
                    </div>
                </div>
            </div>
        </div>
   </div>
</template>

<script>
import CancelIcon from "../core/InlineCancelField.vue";
import 'tui-color-picker/dist/tui-color-picker.css';
import 'tui-image-editor/dist/tui-image-editor.css';
import { ImageEditor } from '@toast-ui/vue-image-editor';
import Utils from '../../components.utils.js';
import {mapActions} from 'vuex';
import FileUploader from '../../plugins/fileUploader.js';
import moment from 'moment';
export default {
   name: 'ImageAnnotationEditor',
   props:['annotationData','isBase64dataRequired','isChatUpload','menuPosition'],
   components:{
       CancelIcon,
       'tui-image-editor': ImageEditor,
   },
   data(){
       return {
            useDefaultUI: true, 
            options: {
                // for tui-image-editor component's "options" prop
                cssMaxWidth: window.innerWidth - 30,
                cssMaxHeight: window.innerHeight - 150,
               includeUI:{
                  loadImage: {
                          path: this.annotationData.thumbnail,
                          name: 'My image',
                  }, 
                  // menu: ['flip','rotate','shape','icon', 'text', 'draw'],
                  menu: ['shape','icon', 'text', 'draw'],
                  initMenu: 'draw',
                  menuBarPosition:  this.menuPosition || "bottom",
               }
            },
           uploadedProxyThumbnailPath:'',
       }
   },
   methods:{
        getUploadedProxyThumbnailPath(){
          return  this.uploadedProxyThumbnailPath;
        },
        getFilenameWithTimestamp: function(){ 
            let file_name = this.annotationData.asset.file_name;
            let lastIndexOfDot = file_name.lastIndexOf('.');
            let namePart = file_name.slice(0,lastIndexOfDot);
            return namePart +'_'+ moment().format('DDMMYY')+"_"+ moment().format('HHmmss') + '.png';
        },
        uploadAnnotationImage(){
           if(this.$refs.tuiImageEditor.invoke('isEmptyUndoStack')){
            /*   let c = window.confirm('There is no changes are you sure to close ?');
              if(c) */
             this.$emit('closeAnnotationEditor');
             return true;
           }
           let base64Image = this.$refs.tuiImageEditor.invoke('toDataURL');
           let base64ImageContent = base64Image;
               base64ImageContent = base64ImageContent.replace(/^data:image\/(png|jpg);base64,/ig, "");
           const blob = Utils.getBase64ToBlob(base64ImageContent, 'image/png');
          let payload = {params:{src_file_uid:this.annotationData.asset.file_uid}};
           this.getProxyBinUploadDetails(payload).then((uplodDetails) => {
                console.log('sending data........',uplodDetails);
               let uniqueIdd = Utils.getUUID();
               let uploader = new FileUploader(blob,uplodDetails.upload_path,uplodDetails.upload_token,uniqueIdd,uniqueIdd,uniqueIdd,uplodDetails.upload_url,'','',false);
               uploader.doUploadOnProxyBin();
               uploader.setFilename(this.getFilenameWithTimestamp());
               uploader.setSourceFileId(this.annotationData.asset.file_uid);
               uploader.setPath();
               console.log(uploader);
               if(this.isChatUpload) uploader.doChatUpload();
               uploader.on("fileUploadDone", () => {
                  this.$nextTick(() => {
                    //  this.$toast.success('Applied Successfully');
                     this.uploadedProxyThumbnailPath = uploader.getDestinationUri();
                     if(this.annotationData && Object.prototype.hasOwnProperty.call(this.annotationData,'isUpdateRequired') && !this.annotationData.isUpdateRequired)
                         if(this.isBase64dataRequired) this.$emit('setBase64Image',base64Image);
                     if(this.annotationData.comment && Object.keys(this.annotationData.comment).length){
                          this.annotationData.comment.markers.frame_thumbnail_uri = uploader.getDestinationUri();
                      }
                     this.$emit('closeAnnotationEditor', uploader.getDestinationUri(), this.annotationData.comment);
                  });
               });
               uploader.on("fail", () => {
                   this.uploadedProxyThumbnailPath = '';
                   this.$toast.error('Some error has occured while uploading Annotation');
               });
               uploader.start();

           }).catch(e => {
               console.log('catch of getProxyBinUploadDetails',e);
               this.uploadedProxyThumbnailPath = '';
               this.$toast.error('Error occured while requesting file upload.');
           });
        },
        relocateElementBySelector(elementSelector, destSelector) {
          let element = document.querySelector(elementSelector);
          let elementParent = element.parentElement;
          let destElement = document.querySelector(destSelector);
          elementParent.removeChild(element);
          destElement.prepend(element);
      },

      addUndoNdDeleteBtn(){
         let partitionLi = document.createElement('li');
         partitionLi.classList.add('tui-image-editor-item');
         partitionLi.classList.add('custom-added');
         partitionLi.innerHTML = `<div class="tui-image-editor-icpartition"></div>`;
         document.querySelector('.tui-image-editor-menu').prepend(partitionLi);
         this.relocateElementBySelector('.tie-btn-delete.tui-image-editor-item.help','.tui-image-editor-menu');
         this.relocateElementBySelector('.tie-btn-redo.tui-image-editor-item.help','.tui-image-editor-menu');
         this.relocateElementBySelector('.tie-btn-undo.tui-image-editor-item.help','.tui-image-editor-menu')
      },
      handleAnnotationEditorKeyBoard(event){
          let keyCode = event.keyCode || event.which;

          if(event.ctrlKey && event.key === 'z') {
              event.preventDefault();
          }

          if(keyCode == 27){ // ESC key
              // this.$emit('closeAnnotationEditor');
              this.closeAnnotationWindow();
              return true;
          }
     },
     closeAnnotationWindow(){
         let c = window.confirm('Discard Annotation ?');
         if(c)
            this.$emit('closeAnnotationEditor');
     },
     ...mapActions('upload',['getProxyBinUploadDetails']),
     ...mapActions('review',['updateCommentData'])
   },
   mounted(){
       let span = document.createElement('span');
       span.classList.add('annotation-apply-button');
       span.onclick = () => {
           this.uploadAnnotationImage();
       };
       span.innerHTML = 
        `<span>  
          <li>
            <div class="btn-group">
                <button type="button" class="btn btn-primary" style="width:114px;">Apply</button>
           </div>
        </li></span>`;
        document.querySelector('.tui-image-editor-menu').appendChild(span);

        window.addEventListener('keydown', this.handleAnnotationEditorKeyBoard);
   },

  beforeDestroy(){
      window.removeEventListener('keydown', this.handleAnnotationEditorKeyBoard);
   }
}
</script>

<style lang="scss" scoped>
$table-row-border: none;
$active-blue: #007bff;
$danger-color: #dc3545;
$none-text-color:#4f4f4f;
$add-button-text-color:#0b7099;
$add-button-text-color-hover:#0193cc;
$add-button-border-color:#b7b228;
$add-button-border-on-hover:#dcd426;
$add-button-backgroud:#1e1e1e;
$active-green-color:#28a745;
$primary-background: #1a1e21;
$border-color: 1px solid #4a4a4a;
$primary-background: #1a1e21;
$secondary-background-color:#15181B;
$bg-color-on-hover: #22272b;
$text-color: #eee;
$dull-text-color: #757575;
$secondary-text-color: #9c9c9c;
$active-blue : #007bff;
$input-field-and-label-font-size:14px;
$input-field-height:38px;
$highlight-font-color:#ff9800;
$scrollbar-thumb-background:#333;
$scrollbar-track-background:#1a1e21;
$scrollbar-thumb-on-hover-background:#555; 
$input-field-padding:.375rem 10px;
$filter-border-color: #5a5a5a;
$filter-bg-color: #2a2a2a;
$learn-about-text-color-hover:#b7b327;
$learn-about-text-color:#9a9620;
$tags-background-color:#282d31;
$svg-color:#666;
$tags-border-color:#363636;
$secondary-border-color: 1px solid #2b2b2b;
$icon-hover:#2c3339;

::v-deep{
   .tui-image-editor-header { display: none !important; }
   .tui-image-editor-container .tui-image-editor-main { top: 0; }
   .tui-image-editor-help-menu.top{display: none !important;}
   .tui-image-editor-virtual-range-pointer{
     background: #fff !important;
   }
   .tie-icon-add-button [data-icontype="icon-star"], [data-icontype="icon-star-2"]{
      display: none !important;
   }
   .tui-image-editor-menu-icon .tui-image-editor-partition, .tui-image-editor-menu-icon .tie-icon-add-button:not(:first-child){
      display: none !important;
   }
   .annotation-apply-button{
      display: inline-block;
      float: inline-end;
      position: relative;
      inset-inline-end: 16px;
      top: 7px;
   }

   .tui-image-editor-item.custom-added{
      top: 9px !important;
    }

    html{
      overflow-y:auto !important;
    }

    .tui-image-editor-submenu{
        visibility: hidden;
        transition: transform 0.6s cubic-bezier(0.83, 0, 0.17, 1);
    }

    .tui-image-editor-controls:hover + .tui-image-editor-main-container  .tui-image-editor-submenu{
        visibility: visible !important;  
    } 

    .tui-image-editor-submenu:hover {
        visibility: visible !important;
    }
}

html{
  overflow-y:auto !important;
}

.modal-dialog {
    width: 100vw;
    height: 100vh;
    max-width:100%;
    margin: 0;
    padding: 0;
  }

 .modal-content {
    height: auto;
    min-height: 100%;
    border: 0 none;
    border-radius: 0;
    box-shadow: none;
    background: $primary-background !important;
    border: $secondary-border-color;
    .modal-body{
      background: $primary-background;
      overflow:auto;
      height:300px;
      padding: 0px 0px 0px 0px;
    //   display:inline-flex;
      width:100%;
      position:relative;
    }
  }

.modal {
  text-align: center;
  padding: 0!important;
  display:block;
}
.modal:before {
  content: '';
  display: inline-block;
  height: 100%;
  vertical-align: middle;
  margin-inline-end: -4px;
}
.modal-dialog {
  display: inline-block;
  text-align: start;
  vertical-align: middle;
}

.modal-header,.modal-footer{
    border-top: $secondary-border-color !important;
    border-bottom: $secondary-border-color !important;
    background: $secondary-background-color;
    align-items: unset;
    .modal-title{
      color:$text-color;
      padding:3px;
    }
}

.modal-title{
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.modal-header .close {
    // margin: -1rem -19px -0rem auto !important;
    margin:0px !important;
    padding: 0px !important;
}

.modal-footer{
    justify-content: start;
    position: fixed;
    inset-inline-start: 0;
    bottom: 0;
    width: 100%;
    height: 50px;
    z-index:9;
}

.close-icon:hover{
  background: $icon-hover;
  border-radius: 20px;
}

</style>